module.exports = __webpack_public_path__ + "img/dgroup_10.5f0dd042.jpg";